// extracted by mini-css-extract-plugin
module.exports = {"container":"SPy3SacZcllPqU1-si20m"};